<template>
  <section class="hero has-image">
    <div class="hero-body">
      <transition name="slide-fade-alt"
                  v-if="eventSequence && (eventSequence !== '1' || eventSequence !== '3') && step === 'start'">
        <div v-if="active" class="block current-nav-step">
          <h1 class="title">{{ $t(`general.hero.startSpecial.title`) }}</h1>
          <h2 class="subtitle">{{ $t(`general.hero.startSpecial.subtitle`) }}</h2>
        </div>
      </transition>
      <template v-else>
        <transition name="slide-fade-alt">
          <div v-if="active" class="block current-nav-step">
            <h1 class="title">{{ $t(`general.hero.${step}.title`) }}</h1>
            <h2 class="subtitle">{{ $t(`general.hero.${step}.subtitle`) }}</h2>
          </div>
        </transition>
      </template>


      <div class="block is-flex nav-steps" v-if="!hideSteps">

        <template v-for="s in activeSteps">

          <div :key="'line-'+s" v-if="s !== 'start'"
               class="step-line" :class="{ isActive: activeSteps.indexOf(s) <= currentStep }"/>
          <div :key="'step-'+s" class="step" :class="{ isActive: activeSteps.indexOf(s) <= currentStep }">
          <div class="step-point is-flex">
            <div class="inner-step-point"/>
          </div>
          <div class="step-title is-flex">
            <p>{{ $t(`general.hero.${s}.stepTitle`) }}</p>
          </div>
        </div>
        </template>

      </div>
    </div>
  </section>
</template>

<script>

import {getURLParameter} from "../helper";

export default {
  name: 'Hero',
  props: {
    step: {
      type: String,
      default: 'start'
    },
  },
  data() {
    return {
      active: false,
      hideSteps: this.step === 'start' || this.step === 'edit' || this.step === 'error',
      currentStep: 0,
      activeSteps: [],
      eventSequence: null
    }
  },
  mounted() {
    this.eventSequence = this.$store.state.eventSequence = getURLParameter('eventSequence');
    
    const steps = {
      1: ['start', 'fahrt', 'checkout'],
      2: ['start', 'fahrt', 'anzahl', 'checkout'],
      3: ['start', 'fahrt', 'daten', 'bestaetigung']
    }
    this.activeSteps = !this.hideSteps ? steps[this.$store.state.reservationType] : null;
    this.currentStep = !this.hideSteps ? this.activeSteps.indexOf(this.step) : null;
    this.active = true;
  }
}
</script>

<style scoped lang="scss">
.hero {
  text-align: center;

  &.has-image {
    background-color: gray;
  }

  .hero-body {
    padding: 3.8rem 0rem 2.5rem 0rem;
    background-image: url('../assets/dachstein-gondel-neu.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    &::before {
      width: 100%;
      height: 100%;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(50, 50, 50, 0.5);
    }
  }

  .block {
    padding-top: 0;
    padding-bottom: 0;
  }

  h1, h2, h3, p {
    color: rgb(255, 255, 255);
  }

  .title {
    font-size: 2.9rem;
    margin-bottom: 1.6rem;
    font-weight: 900;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
}

.current-nav-step {
  position: relative;
  z-index: 10;
}

.nav-steps {
  position: relative;
  z-index: 10;

  .step {
    width: 50px;
    height: 30px;
    position: relative;
    display: block;
    text-align: center;
    opacity: 0.25;
    transition: all 0.5s ease-in-out;

    &.isActive {
      opacity: 1;

      .inner-step-point {
        opacity: 1 !important;
      }
    }

    .step-point {
      width: 30px;
      height: 30px;
      position: relative;
      margin: 0 auto;
      display: block;
      border: 1px solid rgb(255, 255, 255);
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      transition: all 0.5s ease-in-out;

      .inner-step-point {
        width: 22px;
        height: 22px;
        position: relative;
        background: rgb(255, 255, 255);
        border-radius: 50%;
        opacity: 0;
        transition: all 0.5s ease-in-out;
      }
    }

    .step-title {
      font-size: 0.75rem;
      font-weight: bold;
      text-transform: uppercase;
      color: rgb(255, 255, 255);
      position: absolute;
      bottom: -20px;
      left: 0;
      right: 0;
      margin: 0 auto;
      line-height: 120%;
      justify-content: center;
      align-items: center;

      p {
        display: block;
        min-width: 175px;
      }
    }
  }

  .step-line {
    width: 100%;
    height: 1px;
    margin: 10px;
    background-color: rgb(255, 255, 255);
    display: block;
    opacity: 0.25;

    &.isActive {
      opacity: 1;
    }
  }
}

@media (max-width: 680px) {

  .hero {
    overflow: hidden;

    .hero-body {
      padding: 1.8rem 0rem 1.8rem 0rem;
    }

    .nav-steps.block {
      padding: 0rem 1.2rem;
    }

    .title {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }

    .subtitle {
      font-size: 0.8rem;
      margin-bottom: 0rem;
    }

    .nav-steps {
      .step-line {
        margin: 5px;
      }

      .step-title {
        font-size: 0.45em;
        bottom: -14px;
      }
    }
  }
}

// IE11 Step Component fix
@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .nav-steps .step-line {
    margin-left: 27px;
    margin-right: 10px;
  }

  *::-ms-backdrop,
  .nav-steps .step .step-title p {
    margin-left: -1.45vw;
  }
}
</style>
